<template>
  <div id="simple-calendar-app">
    <div class="vx-card app-fixed-height">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="simpleCalendarEvents"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
              <vs-button icon-pack="feather" icon="icon-plus" @click="promptAddNewEvent(new Date())">Add</vs-button>
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex justify-end order-last">
              <div class="flex items-center">
                <feather-icon icon="ChevronLeftIcon" @click="updateMonth(-1)" svgClasses="w-5 h-5 m-1" class="cursor-pointer bg-primary text-white rounded-full" />
                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>
                <feather-icon icon="ChevronRightIcon" @click="updateMonth(1)" svgClasses="w-5 h-5 m-1" class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <vs-button
                class="rounded-r-none p-3 md:px-8 md:py-3"
                @click="calendarView = 'month'">Month</vs-button>
              <vs-button
                class="rounded-l-none p-3 md:px-8 md:py-3"
                @click="calendarView = 'week'">Week</vs-button>
            </div>
          </div>
        </div> 
      </calendar-view>
    </div>

    <!-- ADD EVENT -->
    <vs-prompt
            class="calendar-event-dialog"
            title="Agendar"
            accept-text= "Enviar"
            cancel-text= "Cancelar"
            @accept="addEvent"
            :is-valid="validForm"
            :active.sync="activePromptAddEvent">

            <AppointmentScheduleCreate 
                v-bind:prop_startDate="this.startDate" 
                v-bind:prop_title="this.title" 
                v-on:onTitleChange="onTitleChanged($event)"
                v-on:onStartDateChange="onStartDateChanged($event)"
                @onPatientChanged="onPatientChanged($event)"
                @AppointmentScheduleCreateChanged="onAppointmentScheduleCreateChanged($event)"/>
        </vs-prompt>

    <!-- EDIT EVENT -->
        <vs-prompt
            class="calendar-event-dialog"
            title="Alterar - Agendamento"
            accept-text= "Alterar"
            @accept="editEvent"
            :is-valid="validForm"
            :active.sync="activePromptEditEvent">

            <AppointmentScheduleCreate 
                v-bind:prop_startDate="this.startDate" 
                v-bind:prop_title="this.title" 
                v-bind:prop_scheduleTime="this.scheduleTime"
                v-bind:prop_patient="this.patient"
                @AppointmentScheduleCreateChanged="onAppointmentScheduleCreateChanged($event)"/>
        </vs-prompt>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
require("vue-simple-calendar/static/css/default.css")

import Datepicker from 'vuejs-datepicker';

import AppointmentScheduleCreate from "../appointment/AppointmentScheduleCreate";
import ScheduleService from '../../../services/ScheduleService';

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    AppointmentScheduleCreate
  },
  data() {
    return {
      notifications: 
      {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: [],
        showSucces: true,
        showError: true
      },
      idSchedule: 0,
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: null,
      endDate: '',
      scheduleTime: '',
      labelLocal: 'none',
      url: '',
      calendarView: 'month',
      activePromptAddEvent: false,
      activePromptEditEvent: false,
      patient: null,
      idPatient: 0,
      updateCalendar: true,
    }
  },
  computed: {
    simpleCalendarEvents() {
      if(this.updateCalendar) {
        this.getScheduleEvents();
      }

      return this.$store.state.calendar.simpleCalendarEvents;
    },
    validForm() {
        return this.title != '' && this.startDate != '' && this.scheduleTime != ''},
    disabledDatesTo() {
        return { to: new Date(this.startDate) }
    },
    disabledDatesFrom() {
        return { from: new Date(this.endDate) }
    },
    calendarLabels() {
      return this.$store.state.calendar.calendarLabels
    },
    labelColor() {
        return (label) => {
            if (label == "business") return "success"
            else if (label == "work") return "warning"
            if (label == "personal") return "danger"
            if (label == "none") return "primary"
        }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    async addEvent() {
      this.$vs.loading();

        const payload = {
            data: {
              id: 0,
              IdPatient: this.patient.id,
              ScheduleDate: this.scheduleTime,
              Description: "",
            },
            notifications: this.notifications
        };

        payload.notifications.showSucces = true;

        var result = await ScheduleService.create(payload);

        if(result.status == 200)
        {
          const obj = { 
            title: this.title, 
            startDate: this.scheduleTime, 
            endDate: this.scheduleTime, 
            label: this.labelLocal, 
            url: this.url, 
            patient: this.patient,
            idSchedule: result.data.id 
          };

          obj.classes = "event-" + this.labelColor(this.labelLocal);
          this.$store.dispatch('calendar/addEventToSimpleCalendar', obj);
        }

        this.$vs.loading.close();
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
      this.updateCalendar = true;
    },
    clearFields() {
        this.title = '';
        this.endDate = '';
        this.url = '';
        this.scheduleTime = '';
        this.id= 0;
        this.labelLocal = "none";
    },
    promptAddNewEvent(date) {
        this.disabledFrom = false;
        this.addNewEventDialog(date);
    },
    addNewEventDialog(date) {
        this.clearFields();

        this.startDate = date;
        this.endDate = date;
        this.activePromptAddEvent = true;
    },
    openAddNewEvent(date) {
        this.disabledFrom = true;
        this.addNewEventDialog(date);
    },
    openEditEvent(event) {
      const e = this.$store.getters['calendar/simpleCalendareventById'](event.id);

      this.id = e.id;
      this.title = e.title;
      this.startDate = e.startDate;
      this.endDate = e.endDate;
      this.url = e.url;
      this.patient = e.patient;
      this.activePromptEditEvent = true;
      this.scheduleTime = e.startDate;
      this.idSchedule = e.idSchedule;
    },
    async editEvent() {
      this.$vs.loading();

      const payload = {
        data: {
            id: this.idSchedule,
            IdPatient: this.patient.id,
            ScheduleDate: this.scheduleTime,
            Description: "",
        },
        notifications: this.notifications
      };

      var result = await ScheduleService.update(payload);

      if(result.status == 200)
      {
        const obj = { 
          id: this.id,
          title: this.title, 
          startDate: this.scheduleTime, 
          endDate: this.scheduleTime, 
          label: this.labelLocal, 
          url: this.url, 
          patient: this.patient,
          idSchedule: result.data.id
        };

        obj.classes = "event-" + this.labelColor(this.labelLocal);

        this.$store.dispatch('calendar/editSimpleCalendarEvent', obj);
      }

      this.$vs.loading.close();
    },
    removeEvent() {
      this.$store.dispatch('calendar/removeSimpleCalendarEvent', this.id)
    },
    async eventDragged(event, date) {
      this.$vs.loading();

      var hours = event.startDate.getHours();
      var minutes = event.startDate.getMinutes();
      date.setHours(hours);
      date.setMinutes(minutes);

      const payload = {
        data: {
            id: event.originalEvent.idSchedule,
            IdPatient: event.originalEvent.patient.id,
            ScheduleDate: date,
            Description: "",
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;

      var result = await ScheduleService.update(payload);

      if(result.status == 200) {
       const obj = { 
          id: event.id,
          title: event.title, 
          startDate: date, 
          endDate: date, 
          label: event.labelLocal, 
          url: event.url, 
          patient: event.originalEvent.patient,
          idSchedule: result.data.id
        };

        obj.classes = "event-" + this.labelColor(this.labelLocal);

        this.$store.dispatch('calendar/editSimpleCalendarEvent', obj);
      }

      this.$vs.loading.close();
    },
    onTitleChanged(event) {
        this.title = event;
    },
    onStartDateChanged(event) {
        this.startDate = event;
        this.endDate = event;
    },
    onPatientChanged(patient) {
      this.patient = patient;
    },
    onAppointmentScheduleCreateChanged(appointment) {
      this.title = appointment.eventName;
      this.startDate = appointment.ScheduleDate;
      this.endDate = appointment.ScheduleDate;
      this.patient = appointment.patient;
      this.scheduleTime = appointment.scheduleTime;
      this.idPatient = this.patient.id;
    },
    async getScheduleEvents() {
      this.$vs.loading();
      
      this.updateCalendar = false;

      var scheduleDateStart = new Date(this.showDate.getFullYear(), this.showDate.getMonth());
      scheduleDateStart.setDate(scheduleDateStart.getDate() - 6);
      var scheduleDateEnd = new Date(this.showDate.getFullYear(), this.showDate.getMonth() +1);
      scheduleDateEnd.setDate(scheduleDateEnd.getDate() + 6);

      var payload = {
        data: {
            ScheduleDateStart: scheduleDateStart,
            ScheduleDateEnd: scheduleDateEnd,
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;

      var result = await ScheduleService.search(payload);

      if(result.status == 200) {
        this.$store.dispatch('calendar/clearSimpleCalendarEvent');

        result.data.forEach(event => {
          const obj = { 
            title: event.patient.name, 
            startDate: new Date(Date.parse(event.scheduleDate)), 
            endDate: new Date(Date.parse(event.scheduleDate)), 
            label: event.patient.name,
            url: "", 
            patient: event.patient,
            idSchedule: event.id
          };
          
          obj.classes = "event-" + this.labelColor(this.labelLocal);

          this.$store.dispatch('calendar/addEventToSimpleCalendar', obj);
        });
      }

      this.$vs.loading.close();
    }
  }

}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/apps/simple-calendar.scss";
</style>